export enum QuestionType {
  MCMA = 'MCMA',
  MCSA = 'MCSA',
  FILL_IN_BLANK = 'FILL_IN_BLANK',
  MATCH_LABEL_TEXT = 'MATCH_LABEL_TEXT',
  ORDER = 'ORDER',
  HOTSPOT = 'HOTSPOT',
}
